import {
  ImageBackground,
  StyleSheet,
  useWindowDimensions,
  SafeAreaView,
  TouchableOpacity,
  Animated,
  Platform,
} from "react-native";
import React from "react";
import { TabView, SceneMap } from "react-native-tab-view";
import {
  View,
  Box,
  Center,
  Image,
  ScrollView,
  Flex,
  HStack,
  VStack,
  Heading,
  IconButton,
  Button,
  Pressable,
  Text,
} from "native-base";
const BLOCKS = require("../assets/blocks.png");
const PlayIconImage = require("../assets/playicon.png");
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { StackScreenProps } from "../types";

const ModelFarmImages = [
  require("../assets/gallery/modelfarm/modelfarm1.jpg"),
  require("../assets/gallery/modelfarm/modelfarm2.jpg"),
  require("../assets/gallery/modelfarm/modelfarm3.jpg"),
  require("../assets/gallery/modelfarm/modelfarm4.jpg"),
  require("../assets/gallery/modelfarm/modelfarm5.jpg"),
];

const AgriboosterImages = [
  require("../assets/gallery/agribooster/agribooster1.jpg"),
  require("../assets/gallery/agribooster/agribooster2.jpg"),
  require("../assets/gallery/agribooster/agribooster3.jpg"),
  require("../assets/gallery/agribooster/agribooster4.jpg"),
  require("../assets/gallery/agribooster/agribooster5.jpg"),
  require("../assets/gallery/agribooster/agribooster6.jpg"),
  require("../assets/gallery/agribooster/agribooster7.jpg"),
];

const SchoolLabImages = [
  require("../assets/gallery/schoollab/schoollab1.jpg"),
  require("../assets/gallery/schoollab/schoollab2.jpg"),
  require("../assets/gallery/schoollab/schoollab3.jpg"),
  require("../assets/gallery/schoollab/schoollab4.jpg"),
  require("../assets/gallery/schoollab/schoollab5.jpg"),
  require("../assets/gallery/schoollab/schoollab6.jpg"),
  require("../assets/gallery/schoollab/schoollab7.jpg"),
];

const emayImages = [
  require("../assets/gallery/emay/Farm-and-Fortune-1-min.jpg"),
  require("../assets/gallery/emay/Farm-and-Fortune-2-min.jpg"),
  require("../assets/gallery/emay/Farm-and-Fortune-3-min.jpg"),
  require("../assets/gallery/emay/Farm-and-Fortune-4-min.jpg"),
  require("../assets/gallery/emay/Farm-and-Fortune-5-min.jpg"),
  require("../assets/gallery/emay/Farm-and-Fortune-6-min.jpg"),
  require("../assets/gallery/emay/Farm-and-Fortune-7-min.jpg"),
];

const BlendingPlantImages = [
  require("../assets/gallery/blendingplant/blendingplant1.jpg"),
  require("../assets/gallery/blendingplant/blendingplant2.jpg"),
  require("../assets/gallery/blendingplant/blendingplant3.jpg"),
  require("../assets/gallery/blendingplant/blendingplant4.jpg"),
  require("../assets/gallery/blendingplant/blendingplant5.jpg"),
];

const FirstRoute = () => {
  const video = React.useRef(null);
  const [status, setStatus] = React.useState({});

  return (
    <View flex={1}>
      <ScrollView
        contentContainerStyle={{
          marginTop: 50,
          flex: 1,
          justifyContent: "space-between",
        }}
      >
        <View>
          {[1].map((item, i) => (
            <Box w={"2/3"} h={400} marginX="auto" mb={5} key={i}>
              {/* <iframe
                src="https://www.youtube.com/watch?v=aW7PeGMwbHM"
                width={500}
                height={400}
                style={{
                  // width: "100%",
                  // height: "100%",
                  borderRadius: 15,
                  overflow: "hidden",
                  borderWidth: 2,
                  borderColor: "white",
                }}
              ></iframe> */}
              <iframe
                src="https://www.youtube.com/embed/aW7PeGMwbHM"
                title="Industrial Plant 3D Video"
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: 15,
                  overflow: "hidden",
                  borderWidth: 2,
                  borderColor: "white",
                }}
                // frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                // allowfullscreen
              ></iframe>
            </Box>
          ))}
        </View>

        {/* <BottomSlidingImages /> */}
      </ScrollView>
    </View>
  );
};

const ViewRoute = ({ images }: { images: any[] }) => (
  <View flex={1} px={"12"}>
    <ScrollView
      contentContainerStyle={{
        marginTop: 50,
        flex: 1,
        justifyContent: "space-between",
      }}
    >
      <View>
        {images.map((item, i) => (
          <Box w={"2/3"} h={400} marginX="auto" mb={5} key={i}>
            <ImageBackground
              source={item}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: 15,
                overflow: "hidden",
                borderWidth: 2,
                borderColor: "white",
              }}
              imageStyle={{
                borderRadius: 15,
                backgroundColor: "rgba(0,0,0,.8)",
              }}
            >
              {/* <Center style={styles.cardOverlay}>
                <Image
                  source={PlayIconImage}
                  style={{ height: 40, width: 40 }}
                  alt="icon"
                />
              </Center> */}
            </ImageBackground>
          </Box>
        ))}
      </View>

      {/* <BottomSlidingImages /> */}
    </ScrollView>
  </View>
);

const SecondRoute = () => <ViewRoute images={ModelFarmImages} />;
const ThirdRoute = () => <ViewRoute images={AgriboosterImages} />;
const FourthRoute = () => <ViewRoute images={SchoolLabImages} />;
const FifthRoute = () => <ViewRoute images={emayImages} />;
const SixthRoute = () => <ViewRoute images={BlendingPlantImages} />;

const renderScene = SceneMap({
  first: FirstRoute,
  second: SecondRoute,
  third: ThirdRoute,
  fourth: FourthRoute,
  fifth: FifthRoute,
  sixth: SixthRoute,
});

type Route = { key: string; title: string };
const Gallery = ({ navigation }: StackScreenProps<"Gallery">) => {
  const { width, height } = useWindowDimensions();

  const [index, setIndex] = React.useState(0);
  const [routes] = React.useState([
    { key: "first", title: "Production" },
    { key: "second", title: "Model Farm" },
    { key: "third", title: "Agri booster" },
    { key: "fourth", title: "School Lab" },
    { key: "fifth", title: "Emay" },
    { key: "sixth", title: "Blending Plant" },
  ]);

  const renderTabBar = (props: any) => {
    const inputRange = props.navigationState.routes.map(
      (x: any, i: number) => i
    );

    return (
      <Flex
        direction="row"
        // borderBottomColor="rgba(102, 165, 65, 1)"
        borderColor="#fff"
        borderWidth={1}
        marginX={15}
        borderRadius={15}
        mx={"16"}
      >
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          {props.navigationState.routes.map((route: Route, i: number) => {
            const opacity = props.position.interpolate({
              inputRange,
              outputRange: inputRange.map((inputIndex: number) =>
                inputIndex === i ? 1 : 0.5
              ),
            });

            return (
              <TouchableOpacity
                style={styles.tabItem}
                onPress={() => setIndex(i)}
              >
                <Animated.Text
                  style={{
                    opacity,
                    color: props.navigationState.index == i ? "#fff" : "#111",
                  }}
                >
                  {route.title}
                </Animated.Text>
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      </Flex>
    );
  };

  return (
    <ImageBackground
      source={require("../assets/background.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <HStack
            mb={5}
            px={10}
            mt={Platform.OS == "web" ? "20" : "5"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            {/* <Button
              startIcon={
                <MaterialCommunityIcons name="arrow-left" color={"#fff"} />
              }
              onPress={() => navigation.navigate("Home")}
              variant={"ghost"}
              colorScheme={"white"}
            >
              Back
            </Button> */}
            <Pressable
              flex={1}
              flexDir={"row"}
              alignItems={"center"}
              onPress={() => navigation.navigate("Home")}
            >
              <Text fontSize={17}> ←</Text>
              <Heading textAlign="center" flex={1}>
                Gallery
              </Heading>
            </Pressable>
          </HStack>

          <TabView
            navigationState={{ index, routes }}
            renderScene={renderScene}
            onIndexChange={setIndex}
            initialLayout={{ width }}
            renderTabBar={renderTabBar}
          />
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default Gallery;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(110, 178, 69, 0.8)",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
  tabItem: {
    flex: 1,
    alignItems: "center",
    padding: 16,
  },
});
